import moment from 'moment'

export const productivityColumnFilter = [
  {
    active: true,
    headerName: 'Local',
    field: 'location_name',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Macro Região',
    field: 'macro_region',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Micro Região',
    field: 'micro_region',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Distrito',
    field: 'district_name',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Cidade',
    field: 'city_name',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Estado',
    field: 'state_name',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Agricultor',
    field: 'customer_name',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Ensaio',
    field: 'essay',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Data de Plantio',
    field: 'planting_date',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : moment(value).format('DD/MM/YYYY')),
    filterParams: {
      comparator: (filter, value) => {
        const momentFilter = moment(filter).format('YYYY/MM/DD')
        const momentValue = moment(value).format('YYYY/MM/DD')

        if (momentFilter > momentValue) {
          return -1
        } else if (momentValue > momentFilter) {
          return 1
        }
        return 0
      }
    }
  },
  {
    active: true,
    headerName: 'Fertilidade do Solo',
    field: 'fertility',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Época do Plantio',
    field: 'planting_time',
    filter: 'agTextColumnFilter'
  },
  {
    active: true,
    headerName: 'Data de Colheita',
    field: 'harvest_date',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : moment(value).format('DD/MM/YYYY')),
    filterParams: {
      comparator: (filter, value) => {
        const momentFilter = moment(filter).format('YYYY/MM/DD')
        const momentValue = moment(value).format('YYYY/MM/DD')

        if (momentFilter > momentValue) {
          return -1
        } else if (momentValue > momentFilter) {
          return 1
        }
        return 0
      }
    }
  },
  {
    active: true,
    headerName: 'Variedade',
    field: 'variety',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Tecnologia',
    field: 'technology',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'População Inicial',
    field: 'initialPopulation',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'População Final',
    field: 'finalPopulation',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Produtividade',
    field: 'productivity',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : Number(value))
  },
  {
    active: true,
    headerName: 'Variedade Check',
    field: 'check',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : value)
  },
  {
    active: true,
    headerName: 'Produtividade Check',
    field: 'checkProductivity',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (!value ? ' - ' : Number(value))
  },
  {
    active: true,
    headerName: 'Vitória',
    field: 'victory',
    filter: 'agTextColumnFilter',
    cellRenderer: ({ value }) => (value ? 'Sim' : 'Não')
  }
]
